import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import schema from 'components/Property/List/schema';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import NavigationProvider from 'components/Navigation/Provider';
import usePermissions from 'store/authentication/usePermissions';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { PropertiesQuery } from 'components/Property/Form/graphql';
import { RoutePrivateProps } from 'components/Route/Private/types';

const PropertyForm = React.lazy(() => import('components/Property/Form/Form'));

function ScreensPropertyForm(params: Readonly<RoutePrivateProps>) {
  const propertyPermissions = usePermissions('properties');
  const personPermissions = usePermissions('persons');
  const id = params.id ? Number(params.id) : null;

  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>
        {params.id ? 'Edit Property' : 'Create Property'}
      </DocumentTitle>
      <NavigationProvider
        id={id}
        buildUrl={(nid: string) => `/properties/${nid}/edit`}
        schema={schema}
        query={PropertiesQuery}
      >
        <Suspense fallback={<UILoader />}>
          <PropertyForm
            id={id}
            key={id}
            personPermissions={personPermissions}
            propertyPermissions={propertyPermissions}
          />
        </Suspense>
      </NavigationProvider>
    </BaseLayout>
  );
}

export default ScreensPropertyForm;
